import { endOfToday } from "date-fns";

/**
 * 今日の残り時間をミリ秒で返す
 * `useQuery` の `staleTime` に渡すことで、当日中はキャッシュを使い続ける
 * @example
 * // 現在時刻が 2022-01-01T12:00:00 の場合
 * remainingTimeToday() // 43200000 (12時間)
 */
export function remainingTimeToday() {
  return endOfToday().getTime() - Date.now();
}

/**
 * 5分間の時間
 * @note 5分間の時間は、`useQuery` の `staleTime` に渡すことを想定
 */
export const FIVE_MINUTES = 1000 * 60 * 5;
